<template>
  <ContextMenu :menu="menus" @select="handleClickItem">
    <span>{{ title }}</span>
  </ContextMenu>
</template>

<script>
import ContextMenu from '@/components/base/ContextMenu/index.vue';

export default {
  components: {
    ContextMenu,
  },
  props: {
    title: String,
    tag: Object,
  },
  data(){
    return {
      menus: [
        {action: 'all', label: '关闭所有'},
        {action: 'other', label: '关闭其它'},
        {action: 'self', label: '关闭', disabled: this.tag.meta?.affixTagView},
        {action: 'refresh', label: '刷新'},
        {action: 'clearRouteCache', label: '清空路由缓存'},
      ]
    }
  },
  methods: {
    // 判断是否为当前激活的tag
    isActive(tag){return tag.path === this.$route.path;},
    handleClickItem({action}){
      const {tag} = this;

      switch (action){
        // 删除所有标签导航，只留下固定的标签导航
        case 'all': 
          this.handleCloseAllTag(tag);
          break;
        // 关闭其他标签导航，只留下自己和固定的标签导航
        case 'other': 
          this.handleCloseOtherTag(tag);
          break;
        // 关闭当前页面
        case 'self':
          this.closeSelectedTag(tag);
          break;
        // 刷新当前页面
        case 'refresh':
          this.refreshSelectedTag(tag);
          break;
        // 清除所有路由缓存
        case 'clearRouteCache':
          this.$store.commit('tagsView/clearCacheRouteName');
          break;
      }
    },
    // 删除所有标签导航，只留下固定的标签导航
    handleCloseAllTag(tag){
      this.$store.commit('tagsView/delAllView');
      this.$emit('toLastView', tag);  // 关闭所有后 就让切换到剩下affix中最后⼀个tag
    },
    // 关闭其他标签导航，只留下自己和固定的标签导航
    handleCloseOtherTag(tag){
      this.$store.commit('tagsView/delOthersViews', tag);
      if (!this.isActive(tag)) this.$router.push(tag.path); // 删除其他tag后 让该view路由激活
    },
    // 关闭当前页面
    closeSelectedTag(tag){
      this.$store.commit('tagsView/deleteView', tag);
      if (this.isActive(tag)) this.$emit('toLastView', tag);
    },
    // 刷新当前页面
    refreshSelectedTag(tag){
      this.$store.commit('tagsView/deleteCacheRouteName', tag);
      this.$router.push("/redirect" + tag.path);
    }
  }
}
</script>

<style scoped lang="scss"></style>